import CloseIcon from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Switch from "@mui/material/Switch";
import Toolbar from "@mui/material/Toolbar";
import { TransitionProps } from "@mui/material/transitions";
import Typography from "@mui/material/Typography";
import React from "react";
import { Tutorial } from "./normal-mode/Tutorial";
import { ISettingsReducer, Settings } from "./settings-reducer";

type Props = {
  settings: Settings;
  settingsReducer: ISettingsReducer;
  open: boolean;
  onClose: () => void;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function SettingsDialog({
  settings,
  settingsReducer,
  open,
  onClose,
}: Props) {
  const handleDarkModeChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    settingsReducer.setDarkMode(checked);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar position="relative" color="default">
        <Toolbar>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Settings
          </Typography>

          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          display: "flex",
          width: 1,
          height: 1,
          justifyContent: "center",
          backgroundColor: "background.paper",
        }}
      >
        <Grid container sx={{ maxWidth: "500px", alignContent: "flex-start" }}>
          <Grid item xs={6}>
            <Typography sx={{ p: 1 }}>Dark Mode</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Switch
              checked={settings.darkMode}
              onChange={handleDarkModeChange}
            />
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={12}>
            <Tutorial sx={{ p: 1 }} />
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
